import { type CallLogTag } from '@/types/CallLogTag'
import { firestoreService } from '@/utils/firestoreService'

const COLLECTION = 'call_log_tags'

export const callLogTagService = {
  list: () => firestoreService.list<CallLogTag>(COLLECTION),
  add: (tag: CallLogTag) => firestoreService.add<CallLogTag>(COLLECTION, tag),
  update: (id: string, data: Partial<CallLogTag>) => firestoreService.update(COLLECTION, id, data),
  delete: (id: string) => firestoreService.delete(COLLECTION, id),
}
